<template>
  <section class="sign-up-social-buttons">
    <BravadoTheme forced-theme="light">
      <BravadoButtonV3
        :variant="variant"
        full-width
        class="sign-up-social-buttons__button"
        @click="onClick('linkedin')"
      >
        <img slot="prepend-icon" :src="require('./linkedin-logo.svg')" width="20" height="20" alt="" />
        Continue with LinkedIn
      </BravadoButtonV3>

      <BravadoButtonV3 :variant="variant" full-width class="sign-up-social-buttons__button" @click="onClick('google')">
        <img slot="prepend-icon" :src="require('./google-logo.svg')" width="20" height="20" alt="" />
        Continue with Google
      </BravadoButtonV3>
    </BravadoTheme>
  </section>
</template>

<script lang="ts">
import Vue from 'vue';
import { buildOAuthUrl } from '../utils';
import type { OAuthType, OAuthProvider } from '../types';
import BravadoTheme from '@/components/common/BravadoTheme/BravadoTheme.vue';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';

export default Vue.extend({
  name: 'SignUpSocialButtons',
  components: {
    BravadoButtonV3,
    BravadoTheme,
  },
  props: {
    variant: {
      type: String,
      default: 'blank',
    },
    // OAuthType
    type: {
      type: String,
      default: 'signUp',
    },
    // Additional login params
    loginParams: {
      type: Object,
      default: () => ({}),
    },
    //
    isHandledOutside: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick(provider: OAuthProvider) {
      this.$analytics.logEvent(`global__${this.type}__${provider}-button__click`);

      const loginLink = buildOAuthUrl(provider, this.type as OAuthType, this.$route, this.loginParams);
      this.$emit(`login`, provider, loginLink);

      // Don't handle redirect if it's handled outside (eg we postpone opening for case with additional question)
      if (this.isHandledOutside) return;

      // Ensure that emit fire before redirect
      this.$nextTick(() => {
        window.location.assign(loginLink);
      });
    },
  },
});
</script>

<style lang="scss">
.sign-up-social-buttons {
  &__button {
    margin-bottom: 12px;

    // Modify the "blank" button style to match the design
    &.bravado-button-v3--blank {
      background-color: var(--white);
      box-shadow: var(--theme-elevation-01);
      color: var(--black);
      font-weight: 600;

      &:hover,
      &:focus {
        background-color: var(--gray-10) !important;
      }
    }

    .bravado-button-v3__icon {
      margin-right: 5px !important;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
